<!--NAV BAR-->
<app-navbar>
</app-navbar>
<div class="store-page-overlay"></div>

<div class="container-fluid">
  <div class="row row-sm-offset">

    <div class="col-md-12">
      <div class="store-content">
        <div class="store-inner">
          <div *ngIf="roles.isSuperAdmin" (click)="openModal(0)" class="float-right mr-4 btn btn-success">
            <i class="fas fa-plus"></i> Add
          </div>
          <h4 class="checkout-heading">
            Manage Azure Accounts
          </h4>
          <p class="text-black-50 mt-4">Add/Update/Delete Azure Accounts</p>

        </div>

      </div>



      <div class="row mt-3">
        <div *ngIf="filterId == 0" class="col-md-4 mb-2">
          <input (keyup.enter)="doFilter()" [value]="filterInput" (input)="filterInput = $event.target.value"
            type="text" class="form-control" placeholder="Enter query to filter">
          <label [ngClass]="isFilterEntered ? '' : 'active'" class="error">Search query must be entered.</label>
        </div>
        <div *ngIf="filterId == 0" (click)="doFilter()" class="col-md-1 mb-2">
          <button class="btn btn-success mb-2"><i class="fas fa-filter"></i> Filter</button>
        </div>
        <div *ngIf="filterId > 0 || actualFilterInput?.length > 0" class="col-md-7 mb-2">
          <button (click)="removeFilter()" class="btn btn-secondary float-right"><i class="fas fa-minus"></i>
            Remove Filter</button>
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-md-12 mb-3">

          <div class="table-responsive-sm">
            <table style="width: 100% !important;background-color: #FFF;" class="table table-striped ">
              <thead class="thead-dark bg-info">
                <th scope="col">#</th>
                <th scope="col">Account Name</th>
                <th scope="col">Subscription Id</th>
                <th class="text-center" scope="col">Total Namespaces</th>
                <th class="text-center" scope="col">Total Endpoints</th>
                <th class="text-center" scope="col">Active</th>
                <th *ngIf="roles.isSuperAdmin" class="text-center" scope="col">Manage</th>
              </thead>
              <tr *ngFor="let account of accounts">
                <td>
                  {{account.Id}}
                </td>
                <td>
                  {{account.AccountName}}
                </td>
                <td>
                  {{account.SubscriptionId}}
                </td>
                <td class="text-center">
                  {{account.RelatedNamespacesCount}}
                </td>
                <td class="text-center">
                  {{account.RelatedEndpointsCount}}
                </td>
                <td *ngIf="account.Active" class="text-center">
                  Yes
                </td>
                <td *ngIf="!account.Active" class="text-center">
                  No
                </td>
                <td *ngIf="roles.isSuperAdmin" class="text-center">
                  <i (click)="openModal(account.Id)" class="fad fa-pencil-alt icon-btn text-prime"></i>
                  <i (click)="deleteAccount(account.Id)" class="fad fa-trash-alt icon-btn text-danger"></i>
                </td>
              </tr>

            </table>
          </div>

          <div class="btn-paging-container">
            <ng-container *ngIf="pager.totalItems > 0">
              <div>
                <button (click)="getNextAccountsBatch(false)" class="btn-paging prev"><i
                    class="fas fa-chevron-left"></i></button>

                <ng-container *ngFor="let page of pager.pages">
                  <button (click)="fetchSpecificPage(page)" [ngClass]="{'active': page == pager.currentPage}"
                    class="btn-paging">{{page}}</button>
                </ng-container>

                <button (click)="getNextAccountsBatch(true)" class="btn-paging next"><i
                    class="fas fa-chevron-right"></i></button>
              </div>

            </ng-container>
          </div>
        </div>

      </div>

      <div (click)="logout()" class="log-out">
        <i class="fas fa-sign-out-alt"></i>Log out
      </div>
    </div>



  </div>
</div>

<div *ngIf="isShowSuccess" class="fixed-success">
  <div (click)="closeSuccess()" class="float-right">
    <i class="fas fa-times"></i>
  </div>
  {{successMessage}}
</div>

<div *ngIf="isShowError" class="fixed-error">
  <div (click)="closeError()" class="float-right">
    <i class="fas fa-times"></i>
  </div>
  {{errorMessage}}
</div>

<app-powered-by></app-powered-by>
